import $ from 'jquery';
import wNumb from 'wnumb/';
import noUiSlider from 'nouislider/';

export const init = ($target) => {

	$target.find('.js-slider').each(function() {
		var $this = $(this),
			$textFrom = $this.find('.js-slider__text--from'),
			$textTo = $this.find('.js-slider__text--to'),
			$inpFrom = $this.find('.js-slider__inp--from'),
			$inpTo = $this.find('.js-slider__inp--to'),
			$slider = $this.find('.js-slider__range').get(0),
			start = Number($this.data('start')),
			end = Number($this.data('end')),
			min = Number($this.data('min')),
			max = Number($this.data('max')),
			step = Number($this.data('step')),
			tooltips = $this.data('tooltips'),
			slider = null;

		slider = noUiSlider
			.create($slider, {
				start: [ start, end ],
				connect: true,
				step: step,
				tooltips: tooltips,
				range: {
					'min': min,
					'max': max,
				},
				format: wNumb({
					decimals: 0,
				}),
			});

		$slider.noUiSlider.on('slide', function(values) {
			$textFrom.text(values[0]);
			$textTo.text(values[1]);
		});

		$slider.noUiSlider.on('slide', function(values) {
			$inpFrom.val(values[0]).trigger('change');
			$inpTo.val(values[1]).trigger('change');
		});

		$('.f-filter__multislider input[type=number]').on('change', function() {
			$slider.noUiSlider.updateOptions({
				start: [ $inpFrom.val(), $inpTo.val() ],
			});
		});

		// Ondra - autosubmit
		var timeout = null;
		var autosubmitNow = function() {
			var $form = $this.closest('form');
			if ($form.is('.js-slider-autosubmit')) {
				$form.submit();
			}
		};
		$slider.noUiSlider.on('change', function() {
			if (timeout) {
				clearTimeout(timeout);
				timeout = null;
			}
			timeout = setTimeout(function() {
				autosubmitNow();
			}, 750);
		});		
		$slider.noUiSlider.on('update', function() {
			if (timeout) {
				clearTimeout(timeout);
				timeout = null;
			}
		});

	});

};
